import { RootStateOrAny } from 'react-redux';

export const getRenderPartialOnly = (state: RootStateOrAny) => state.getIn(['rendering', 'renderPartialOnly'], false);

export default getRenderPartialOnly;
